import React from 'react';
import AnalizeClienti from './Analize';
import Ws from '../../providers/Ws';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, FormControl, Select, InputLabel, Input, MenuItem } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';
import FromServer from './FromServer';


export default class ComparatieRealizatPlanificat extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
        objVenituri:{},
        objCheltuieli:{},
        listPlan:[],
        listPlanAll:[],
        strTip: 'Venituri',
        listTipuri: ['Venituri', 'Cheltuieli'],
}
    }

   
     componentDidMount(){

      this.getRealizaPlanificat()
    }

    getRealizaPlanificat = async()=>{
       
        let fs = new FromServer()

        let getRealizaPlanificat = await fs.getRealizatPlanificat()

        // console.log('object :', getRealizaPlanificat.plan);
     
        this.setState({
          objVenituri:getRealizaPlanificat.venituri,
          objCheltuieli:getRealizaPlanificat.cheltuieli,
          listPlan:getRealizaPlanificat.plan,
          listPlanAll:getRealizaPlanificat.plan,
        })
     
       


    }

    changeTip = (ev) =>{
        let listPlan = [...this.state.listPlanAll]

        let listPlanFilter = listPlan.filter(l =>l.tip === ev.target.value )

        this.setState({strTip:ev.target.value,
                        listPlan:listPlanFilter})
    }
     render() { 
       return (
          <div>
            <h1 className='pm-title'>{this.dictionary.financiarContabil.comparatieRealizatPlanificat}</h1>
            <Grid style={{marginBottom:50}} className='container'  container>
                           
                               
                           <Grid style={{border:'1px solid black'}}  item xs={12} sm={12} md={6} lg={6} xl={6} >
                            
                               <p><b>{this.dictionary.financiarContabil.venituri}: </b> {this.state.objVenituri.totalVenituriBilant} lei</p>
                               <p><b>{this.dictionary.financiarContabil.venituriPlanificate}:</b>  {this.state.objVenituri.totalVenituriPlanificate} lei</p>
                           </Grid>

                           <Grid style={{border:'1px solid black'}} item xs={12} sm={12} md={6} lg={6} xl={6} >
                      
                               <p><b>{this.dictionary.financiarContabil.cheltuieli}: </b>{this.state.objCheltuieli.totalCheltuieliBilant} lei</p>
                               <p><b>{this.dictionary.financiarContabil.cheltuieliPlanificate}:</b> {this.state.objCheltuieli.totalCheltuieliPlanificate} lei</p>
                           </Grid>
                        
                  
                   
                     </Grid>

                     <div className='container'>
                    
                        <FormControl className='inputFocus' style={{ width: '20%', marginTop: 16, marginBottom:20 }}>
                            <InputLabel htmlFor="resursa">{this.dictionary.financiarContabil.tip}</InputLabel>
                            <Select

                                value={this.state.strTip || ""}
                                onChange={this.changeTip}

                                input={<Input id="resursa" />}>


                                {this.state.listTipuri.map((s, idx) => {
                                    return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                    {this.state.listPlan &&
                      <Table style={{ width: '90%', margin: 'auto' }}>
                      <TableHead>
                          <TableRow style={{}}>

                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.anul}
                              </TableCell>
                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.luna}
                              </TableCell>
                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.tip}
                              </TableCell>
                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.cont}
                              </TableCell>
                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.valoare}
                              </TableCell>



                          </TableRow>
                      </TableHead>

                      <TableBody>
                          {this.state.listPlan.map((l, idx) => {
                              return (
                                  <TableRow  style={{ cursor: 'pointer' }} key={idx}>
                                      <TableCell style={{ textAlign: 'center' }}>
                                          {l.an}
                                      </TableCell>

                                      <TableCell style={{ textAlign: 'center' }} >
                                          {l.luna}
                                      </TableCell>
                                      <TableCell style={{ textAlign: 'center' }} >
                                          {l.tip}
                                      </TableCell>
                                      <TableCell style={{ textAlign: 'center' }} >
                                          {l.cont}
                                      </TableCell>
                                      <TableCell style={{ textAlign: 'center' }} >
                                          {l.valoare} Lei
                                      </TableCell>
                                   

                                  </TableRow>
                              )
                          })}
                      </TableBody>
                  </Table>   
                }

                </div>
                 
         </div>
        );
       }
}